import { useState, useEffect, memo } from 'react';
import api from '../lib/api';
import { Badge } from '../components/ui/badge';
import { ScrollArea } from '../components/ui/scroll-area';
import { Skeleton } from '../components/ui/skeleton';
import {
  Calendar, ChevronDown, ChevronRight
} from 'lucide-react';

export default memo(function SeasonInfo() {
  const [season, setSeason] = useState(null);
  const [snapshots, setSnapshots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showHistory, setShowHistory] = useState(false);

  useEffect(() => {
    Promise.all([
      api.get('/season/current'),
      api.get('/season/history').catch(() => ({ data: { snapshots: [] } }))
    ]).then(([sRes, hRes]) => {
      setSeason(sRes.data.season);
      setSnapshots(hRes.data.snapshots || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  if (loading) return <Skeleton className="h-20 w-full rounded-2xl" />;

  return (
    <div className="bg-card border border-border/60 rounded-2xl p-4" data-testid="season-info">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <Calendar className="h-4 w-4 text-[hsl(var(--accent))]" />
          <h3 className="text-sm font-semibold">{season?.name || 'Season 1'}</h3>
        </div>
        <Badge variant="secondary" className="text-[10px] tabular-nums">
          Week {season?.display_week || season?.week || 1}
        </Badge>
      </div>

      {snapshots.length > 0 && (
        <button
          className="w-full flex items-center justify-between text-xs text-muted-foreground mt-2 hover:text-foreground"
          onClick={() => setShowHistory(!showHistory)}
        >
          <span>Week History ({snapshots.length} weeks)</span>
          {showHistory ? <ChevronDown className="h-3 w-3" /> : <ChevronRight className="h-3 w-3" />}
        </button>
      )}

      {showHistory && snapshots.length > 0 && (
        <ScrollArea className="h-[200px] mt-2">
          <div className="space-y-2">
            {snapshots.map((snap) => (
              <div key={snap.id} className="bg-secondary/30 rounded-lg p-2">
                <p className="text-xs font-semibold mb-1">Week {snap.week}</p>
                <div className="space-y-0.5">
                  {(snap.leaderboard || []).slice(0, 3).map((team, i) => (
                    <div key={i} className="flex items-center justify-between text-[10px]">
                      <span>#{i + 1} {team.name}</span>
                      <span className="tabular-nums">{team.total_points?.toFixed(2)} pts</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </ScrollArea>
      )}
    </div>
  );
});
